<template>
  <div>
    <div class="toolbar">
      <el-radio-group v-model="status" size="small" @change="load">
        <el-radio-button label="PENDING">待开票</el-radio-button>
        <el-radio-button label="ISSUED">已开票</el-radio-button>
        <el-radio-button label="ALL">全部</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="tenantName" label="企业" min-width="150" />
      <el-table-column prop="tenantCode" label="租户编码" width="130" />
      <el-table-column prop="planName" label="套餐" width="110" />
      <el-table-column label="金额" width="100">
        <template slot-scope="{ row }">{{ formatPrice(row.amountCent) }}</template>
      </el-table-column>
      <el-table-column prop="invoiceTitle" label="发票抬头" min-width="150" show-overflow-tooltip />
      <el-table-column prop="invoiceTaxNo" label="税号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="invoiceEmail" label="收票邮箱" min-width="140" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="申请时间" width="170" />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
          <el-button v-if="row.status === 'PENDING'" type="text" @click="openIssue(row)">上传发票</el-button>
          <el-button
            v-else-if="row.invoiceFileUrl"
            type="text"
            @click="openFile(row.invoiceFileUrl)"
          >查看发票</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="开票信息" :visible.sync="detailVisible" width="520px" append-to-body>
      <el-alert
        type="warning"
        :closable="false"
        show-icon
        title="只开 1% 的增值税普通发票"
        style="margin-bottom:14px"
      />
      <el-descriptions v-if="current" :column="1" border size="small">
        <el-descriptions-item label="企业">{{ current.tenantName }}（{{ current.tenantCode }}）</el-descriptions-item>
        <el-descriptions-item label="套餐">{{ current.planName }} · {{ formatPrice(current.amountCent) }}</el-descriptions-item>
        <el-descriptions-item label="发票抬头">{{ current.invoiceTitle }}</el-descriptions-item>
        <el-descriptions-item label="税号">{{ current.invoiceTaxNo }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ current.invoiceAddress || '-' }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ current.invoicePhone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{ current.invoiceBankName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{ current.invoiceBankAccount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收票邮箱">{{ current.invoiceEmail || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ current.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="current && current.status === 'PENDING'" type="primary" @click="openIssue(current)">上传发票</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上传电子发票" :visible.sync="issueVisible" width="460px" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="电子发票" required>
          <el-upload
            action="#"
            :http-request="elUploadHttpRequest"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="onUploadSuccess"
            accept=".pdf,.png,.jpg,.jpeg,.ofd"
          >
            <el-button size="small" type="primary" plain :loading="uploading">选择文件上传</el-button>
          </el-upload>
          <div v-if="issueForm.invoiceFileUrl" class="file-ok">
            已上传：
            <a :href="issueForm.invoiceFileUrl" target="_blank" rel="noopener">{{ issueForm.invoiceFileName || '查看文件' }}</a>
          </div>
          <div class="hint">支持 PDF / 图片 / OFD，建议 PDF</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="issueForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="issueVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitIssue">确认开票</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listInvoiceApplies, issueInvoiceApply } from '../../api/sys'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'SysInvoiceApply',
  data() {
    return {
      loading: false,
      saving: false,
      uploading: false,
      status: 'PENDING',
      list: [],
      detailVisible: false,
      issueVisible: false,
      current: null,
      issueForm: {
        id: null,
        invoiceFileUrl: '',
        invoiceFileName: '',
        remark: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    statusText(status) {
      const map = { PENDING: '待开票', ISSUED: '已开票' }
      return map[status] || status || '-'
    },
    formatPrice(cent) {
      if (cent == null) return '-'
      return (Number(cent) / 100).toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' 元'
    },
    async load() {
      this.loading = true
      try {
        const res = await listInvoiceApplies({ status: this.status })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    openDetail(row) {
      this.current = row
      this.detailVisible = true
    },
    openIssue(row) {
      this.detailVisible = false
      this.issueForm = {
        id: row.id,
        invoiceFileUrl: row.invoiceFileUrl || '',
        invoiceFileName: row.invoiceFileName || '',
        remark: row.remark || ''
      }
      this.issueVisible = true
    },
    beforeUpload(file) {
      if (!file) return false
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning('文件请小于 20MB')
        return false
      }
      this.uploading = true
      return true
    },
    onUploadSuccess(res) {
      this.uploading = false
      const data = (res && res.data) || {}
      if (res && res.code && res.code !== 200) {
        this.$message.error(res.message || '上传失败')
        return
      }
      const url = data.url || ''
      if (!url) {
        this.$message.error('上传失败')
        return
      }
      this.issueForm.invoiceFileUrl = url
      this.issueForm.invoiceFileName = data.fileName || data.originalName || data.name || '电子发票'
      this.$message.success('文件已上传')
    },
    async submitIssue() {
      if (!this.issueForm.id) return
      if (!this.issueForm.invoiceFileUrl) return this.$message.warning('请先上传电子发票')
      this.saving = true
      try {
        await issueInvoiceApply(this.issueForm.id, {
          invoiceFileUrl: this.issueForm.invoiceFileUrl,
          invoiceFileName: this.issueForm.invoiceFileName,
          remark: this.issueForm.remark
        })
        this.issueVisible = false
        this.$message.success('已开票')
        this.load()
      } finally {
        this.saving = false
      }
    },
    openFile(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom: 12px; }
.hint { margin-top: 6px; font-size: 12px; color: #94a3b8; }
.file-ok { margin-top: 8px; font-size: 13px; word-break: break-all; }
</style>
